import { render, staticRenderFns } from "./r-guard-money-panel.vue?vue&type=template&id=1b032702"
import script from "./r-guard-money-panel.vue?vue&type=script&lang=js"
export * from "./r-guard-money-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b032702')) {
      api.createRecord('1b032702', component.options)
    } else {
      api.reload('1b032702', component.options)
    }
    module.hot.accept("./r-guard-money-panel.vue?vue&type=template&id=1b032702", function () {
      api.rerender('1b032702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/guard/r-guard-money-panel.vue"
export default component.exports